import RaporMutu from './RaporMutu';
import PaktaIntegritas from './PaktaIntegritas';
import LembarRaporMutu from './LembarRaporMutu';

export const RaporMutuConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/RaporMutu',
            component: RaporMutu
        }
        ,{
            path     : '/HasilRaporMutu',
            component: LembarRaporMutu
        }
        ,{
            path     : '/PaktaIntegritas',
            component: PaktaIntegritas
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/RaporMutuConfig.js